import React, { useState, useEffect } from 'react';

const DebugOverlay = ({ isVisible = false, showElementBoundaries = true }) => {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    if (!isVisible || !showElementBoundaries) return;

    const highlightElements = () => {
      const allElements = document.querySelectorAll('*');
      const elementInfo = [];

      allElements.forEach((el, index) => {
        const rect = el.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(el);
        
        // Only highlight elements that are visible and have meaningful size
        if (rect.width > 0 && rect.height > 0 && 
            computedStyle.display !== 'none' && 
            computedStyle.visibility !== 'hidden') {
          
          elementInfo.push({
            id: el.id || `element-${index}`,
            className: el.className,
            tagName: el.tagName,
            rect: {
              x: rect.x,
              y: rect.y,
              width: rect.width,
              height: rect.height
            },
            position: computedStyle.position,
            zIndex: computedStyle.zIndex,
            backgroundColor: computedStyle.backgroundColor,
            border: computedStyle.border
          });
        }
      });

      setElements(elementInfo);
    };

    highlightElements();
    
    const interval = setInterval(highlightElements, 1000); // Update every second
    return () => clearInterval(interval);
  }, [isVisible, showElementBoundaries]);

  if (!isVisible) {
    return null;
  }
  

  return (
    <div
      className="debug-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 9998,
        opacity: 1
      }}
    >
      {elements.map((element, index) => {
        // Only highlight elements that are meaningful (not the overlay itself)
        if (element.tagName.toLowerCase() === 'div' && 
            (element.className.includes('grid-overlay') || 
             element.className.includes('debug-overlay') ||
             element.id === 'developer-console' ||
             element.rect.width === 0 ||
             element.rect.height === 0)) {
          return null;
        }

        // Only show elements that are actually visible and meaningful
        if (element.rect.width < 10 || element.rect.height < 10) {
          return null;
        }

        return (
          <div
            key={element.id}
            style={{
              position: 'absolute',
              left: element.rect.x,
              top: element.rect.y,
              width: element.rect.width,
              height: element.rect.height,
              border: '2px solid #ff00ff',
              backgroundColor: 'transparent', // Changed from rgba to transparent
              pointerEvents: 'none',
              fontSize: '10px',
              color: '#ff00ff',
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'flex-start',
              padding: '2px',
              overflow: 'hidden',
              boxSizing: 'border-box'
            }}
          >
            {/* Only show labels for larger elements */}
            {element.rect.width > 50 && element.rect.height > 20 && (
              <div style={{ 
                backgroundColor: 'rgba(0, 0, 0, 0.8)', 
                color: '#ff00ff', 
                padding: '1px 3px',
                fontSize: '8px',
                borderRadius: '2px',
                whiteSpace: 'nowrap',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {element.tagName.toLowerCase()}
                {element.className && `.${element.className.split(' ')[0]}`}
                {element.id && `#${element.id}`}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DebugOverlay;
